// 头像框选择弹窗
import CustomPopup from "../../../../components/CustomPopup";
import React, {useContext, useEffect, useState} from "react";
import {ModalProps} from "../../../../types/IPage.ts";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import './AvatarFrameDialog.css';
import {IAvatarFrame} from "../../../../common/utils/http/IResponse.ts";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import {ToastContext} from "../../../../components/CustomToast/ToastProvider.tsx";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import {useUserContext} from "../../../../providers/userProvider/user-context.tsx";

// 头像框选择弹窗
const AvatarFrameDialog: React.FC<ModalProps> = ({isOpen, onClose}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    // 全局用户信息provider
    const {setUser} = useUserContext();
    const {addToast} = useContext(ToastContext);
    // 加载中弹窗
    const {showLoading, hideLoading} = useLoading();
    // 头像框列表
    const [avatarFrameList, setAvatarFrameList] = useState<IAvatarFrame[]>([])
    // 当前选中的头像框id
    const [currentAvatarFrame, setCurrentAvatarFrame] = useState<IAvatarFrame | null>(null)

    useEffect(() => {
        if (isOpen) {
            // GA埋点
            GAEvents.avatarShow()

            getAvatarFrameList();
        }
    }, [isOpen]);

    // 获取头像框列表
    const getAvatarFrameList = async () => {
        const response = await apiService.loadAvatarFrameList()
        if (response.code === 200) {
            setAvatarFrameList(response.data)
        }
    };

    // 设置当前选中的头像框
    const setCurrentAvatarFrameHandler = (frame: IAvatarFrame) => {
        setCurrentAvatarFrame(frame);
    };

    // 装备头像框
    const equipAvatarFrame = async () => {
        try {
            if (!currentAvatarFrame) return;
            if (!currentAvatarFrame.hasGot) return;
            showLoading();
            const response = await apiService.equipAvatarFrame(currentAvatarFrame.id, !currentAvatarFrame.hasEquipped)
            if (response.code === 200) {
                addToast({type: 'success', message: response.message})
                // 重载头像框列表
                getAvatarFrameList();
                // 刷新用户头像框
                if(!currentAvatarFrame.hasEquipped) {
                    setUser((pre) => ({...pre, avatarFrame: currentAvatarFrame.avatarFrameUrl}))
                } else {
                     setUser((pre) => ({...pre, avatarFrame: null}))
                }
                setCurrentAvatarFrame(null)
                onClose();
            } else {
                addToast({type: 'error', message: response.message})
            }
        } finally {
            hideLoading();
        }
    }

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="avatar-frame-modal-container">
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom-116" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                {/*标题*/}
                <div className="modal-title my-roboto-bold">
                    Avatar Frame
                    <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="right-close-button"
                         alt="关闭"/>
                </div>
                {/*头像框列表*/}
                <div
                    className="width-273 height-220 border-radius-6 bg-color-cyan margin-left-right-auto margin-top-14 display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                    {/*可滚动九宫格*/}
                    <div
                        className="overflow-y-auto height-220 padding-top-14 padding-bottom-14 width-240 avatar-frame-modal-grid-container">
                        {avatarFrameList.map((item) => {
                            return (
                                <div onClick={() => setCurrentAvatarFrameHandler(item)}
                                     key={item.id}
                                     className="height-66 width-66 position-relative">
                                    {/*打勾*/}
                                    {item.hasGot ? undefined : <div
                                        className="height-56 width-56 margin-left-5 margin-top-5 position-absolute border-radius-round bg-color-grey-overlay position-left-0 position-right-0 display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                                        <img className="height-16 width-16" src={imgUrls.lockWhiteIcon} alt="pic"/>
                                    </div>}
                                    <img
                                        className="height-66 width-66 position-absolute object-fit-contain" src={item.avatarFrameUrl}
                                        alt="pic"/>
                                    <img className="height-56 width-56 z-index-minus-2 margin-left-5 margin-top-5 object-fit-contain"
                                         src={imgUrls.defaultAvatarUrl} alt="pic"/>
                                    {currentAvatarFrame?.id === item.id &&
                                        <img className="width-16 height-16 position-absolute right-0 position-bottom-0"
                                             src={imgUrls.checkedBlueIcon} alt="c"/>}
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
                <div
                    className="margin-top-14 height-27 font-size-16 my-roboto-bold display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                    {currentAvatarFrame?.avatarFrameName ?? 'Default'}
                </div>
                {/*分割线*/}
                <div className="split-line-1 width-273 margin-left-right-auto margin-top-6"/>
                <div
                    className="margin-top-6 width-273 text-center margin-left-right-auto color-grey my-roboto-regular font-size-11">
                    {currentAvatarFrame?.description ?? ''}
                </div>
                {/*按钮*/}
                <div onClick={equipAvatarFrame}
                     className={`${currentAvatarFrame?.hasGot ? currentAvatarFrame?.hasEquipped ? 'bg-btn-orange' : 'bg-btn-blue-color' : 'bg-color-grey-btn'} margin-top-auto margin-bottom-14 margin-left-right-auto width-133 height-43 border-radius-34 display-flex-row display-flex-align-items-center display-flex-justify-content-center color-white my-roboto-medium font-size-16`}>
                    {currentAvatarFrame?.hasGot ? currentAvatarFrame?.hasEquipped ? 'Unequip' : 'Equip' : 'Locked'}
                </div>
            </div>
        </CustomPopup>
    );
};

export default AvatarFrameDialog;